import { Star, Calendar } from "lucide-react";

export default function ExpertCard({ expert }) {
  const { initials, name, specialty, institution, rating, rate } = expert;

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 flex flex-col h-full">
      {/* Top: avatar + details */}
      <div className="flex items-start gap-3 sm:gap-4 mb-5">
        <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-sm font-bold flex items-center justify-center shrink-0">
          {initials}
        </div>
        <div className="min-w-0">
          <h3 className="font-bold text-gray-900 truncate">{name}</h3>
          <p className="text-sm text-gray-500 truncate">{specialty}</p>
          <p className="text-sm text-gray-500 truncate mb-1">{institution}</p>
          <p className="flex items-center gap-1 text-sm">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400 shrink-0" />
            <span className="font-medium text-gray-700">{rating}</span>
          </p>
        </div>
      </div>

      {/* Bottom: price + book, pushed to bottom of card */}
      <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
        <div>
          <p className="text-xs text-gray-500 mb-0.5">Consultation</p>
          <p className="font-semibold text-indigo-600 text-sm sm:text-base">
            ₹{rate.toLocaleString("en-IN")}/session
          </p>
        </div>
        <button className="flex items-center gap-1.5 bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition shrink-0">
          <Calendar className="w-4 h-4" /> Book
        </button>
      </div>
    </div>
  );
}